module.exports = __webpack_public_path__ + "static/Review-img-2-3ef81e408dae0936d8062770dfc9e647.png";